import store from "@/store";
import { Header } from "element-ui";
const axios = require("axios");

class MyAxios {
    constructor(url, postData) {
        let finalpost = Object.assign(postData, {
            token: store.state.token,
        });
        this.m_axios = axios.post(url, finalpost);
    }

    then(callback) {
        this.m_axios = this.m_axios.then(response => {
            if (response.data.result == "Fail") {
                console.log(response);
                store.commit("SHOW_TIP", [response.data.msg, 2]);
            } else if (response.data.result != "OK") {
                store.commit("SHOW_TIP", ["登入时间过期，请重新登入", 2]);
                store.commit("LOG_OUT");
                return;
            }
            callback(response);
        });
        return this;
    }
    catch (callback) {
        this.m_axios = this.m_axios.catch(error => {
            console.log(error);
            store.commit("SHOW_TIP", ["网络错误", 2]);
            if (typeof callback == "function") {
                callback();
            }
        });
    }
}

axios.interceptors.response.use(
    function(response) {
        // console.log(response);
        return response;
    },
    function(error) {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

export default {
    // 0-info 1-success 2-error
    ShowTip(msg, type = 0) {
        store.commit("SHOW_TIP", [msg, type]);
    },
    post1(url, postData) {
        return new MyAxios(url, postData);
    },
    async post(url, postData) {
        let finalpost = Object.assign(postData, {
            token: store.state.token,
        });
        let result;
        await axios
            .post(url, finalpost, { timeout: 1000 * 60 })
            .then(response => {
                if (response.status === 200) {
                    if (response.data.result == "Fail") {
                        if (response.data.msg == "非法用户") {
                            store.commit("SHOW_TIP", ["账号在其他设备上登录", 2]);
							store.commit("LOG_OUT");
                        } else {
                            store.commit("SHOW_TIP", [response.data.msg, 2]);
                        }
                    } else if (response.data.result != "OK") {
                        store.commit("SHOW_TIP", ["登入时间过期，请重新登入", 2]);
                        store.commit("LOG_OUT");
                        return;
                    }
                    result = response;
                }
            })
            .catch(error => {
                result = error.response;
                console.log(error.response);
                if (error.response) {
                    if (error.response.status === 404) {
                        store.commit("SHOW_TIP", ["404错误：" + error.response.statusText, 2]);
                    } else if (error.response.status === 500) {
                        if (error.response.statusText === "Internal Server Error") {
                            store.commit("SHOW_TIP", [
                                "500错误：连接服务器出现问题，请检查相关信息，稍后重试",
                                2,
                            ]);
                        } else {
                            store.commit("SHOW_TIP", [
                                "500错误：" + error.response.statusText + "，请稍后重试",
                                2,
                            ]);
                        }
                    }
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log("Error", error.message);
                }
            });
        return result;
    },
    async postBlob(url, postData) {
        let result;
        let finalpost = Object.assign(postData, {
            token: store.state.token,
        });
        await axios({
                method: "post",
                url: url,
                data: finalpost,
                responseType: "blob",
            })
            .then(response => {
                result = response;
            })
            .catch(error => {});
        return result;
    },
};